/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, November 23rd 2022, 5:26:23 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { getEnv } from "config";

const ContainerID = getEnv("REACT_APP_GOOGLE_TAG_MANAGER_CONTAINER_ID");

/**
 * Using Google Tag Manager to manage our analytics, google Ads and all other google tags we need for
 * marketing and analytics.
 *
 * All tags can now be managed from Google Tag Manager
 *
 * @returns null
 */

export const initializeGoogleTagManager = () => {
  if (!ContainerID) return;

  const googleTagScript = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','${ContainerID}');`;

  const script = document.createElement("script");
  script.innerHTML = googleTagScript;
  document.head.appendChild(script);
};
